import { FC, ReactNode, useCallback, useMemo } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import classNames from 'classnames';

import useRiskSupplementCategories from '@store/hooks/useRiskSupplementCategories';

import './style.scss';

interface IProps {
  value: string;
  onChange: (event: SelectChangeEvent, child: ReactNode) => void;
  onClear: () => void;
}

const HRSFilters: FC<IProps> = ({ value, onChange, onClear }): JSX.Element => {
  const categories = useRiskSupplementCategories();

  const categoriesDict = useMemo(() => {
    if (!categories) {
      return new Map();
    }
    return new Map(categories.map(item => [item.id, item.name]));
  }, [categories]);

  const selectRenderValue = useCallback(
    (value: string) => {
      if (!value) {
        return 'CATEGORY';
      }
      return categoriesDict.get(value) || '';
    },
    [categoriesDict],
  );

  return (
    <Box className="high-risk-supplements__filter-wrapper">
      <Select
        className="high-risk-supplements__filter-select"
        onChange={onChange}
        value={value}
        displayEmpty
        disabled={!categories || !categories?.length}
        renderValue={selectRenderValue}
        // eslint-disable-next-line react/no-unstable-nested-components
        IconComponent={e =>
          value ? (
            <CloseIcon
              onClick={onClear}
              className={classNames(e.className, 'high-risk-supplements__filter-icon')}
            />
          ) : (
            <ArrowDropDownIcon className={e.className} />
          )
        }
      >
        {categories?.map(item => (
          <MenuItem key={item.id} value={item.id as number}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default HRSFilters;
